import { DEFAULT_REPORT_SECTION } from "../../classes/constants/reportConstants";
import reportManager from "../report/ReportManager";

export const saveScreenshotToReport = async (section, blob, metadata = {}) => {
  if (!(blob instanceof Blob)) {
    throw new Error("saveScreenshotToReport expects a Blob instance");
  }

  try {
    return await reportManager.addBlob({
      section: section || DEFAULT_REPORT_SECTION,
      blob,
      metadata,
    });
  } catch (error) {
    throw error;
  }
};

export const removeScreenshotFromReport = async id => {
  await reportManager.remove(id);
};

export const clearReportSection = async section => {
  await reportManager.clearSection(section);
};

export const clearReportStore = async () => {
  await reportManager.clearSession();
};
